import { render, staticRenderFns } from "./playlist.vue?vue&type=template&id=04744685"
import script from "./playlist.vue?vue&type=script&lang=js"
export * from "./playlist.vue?vue&type=script&lang=js"
import style0 from "./playlist.vue?vue&type=style&index=0&id=04744685&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports